var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.126 10.168a.5.5 0 0 0 .748.664l3.704-4.168a1 1 0 0 0 0-1.328L1.874 1.168a.5.5 0 0 0-.748.664L4.831 6zm5 0a.5.5 0 0 0 .748.664l3.704-4.168a1 1 0 0 0 0-1.328L6.874 1.168a.5.5 0 0 0-.748.664L9.831 6z",
    clipRule: "evenodd"
  })));
});
const SvgDoubleChevronRightsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleChevronRightsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjEyNjMgMTAuMTY3OEMwLjk0Mjg0MiAxMC4zNzQyIDAuOTYxNDMyIDEwLjY5MDIgMS4xNjc4MiAxMC44NzM3QzEuMzc0MjEgMTEuMDU3MiAxLjY5MDI1IDExLjAzODYgMS44NzM3MSAxMC44MzIyTDUuNTc4NDQgNi42NjQzNkM1LjkxNTIyIDYuMjg1NDcgNS45MTUyMiA1LjcxNDUyIDUuNTc4NDQgNS4zMzU2M0wxLjg3MzcxIDEuMTY3ODFDMS42OTAyNSAwLjk2MTQyIDEuMzc0MjEgMC45NDI4MyAxLjE2NzgyIDEuMTI2MjlDMC45NjE0MzIgMS4zMDk3NSAwLjk0Mjg0MiAxLjYyNTc4IDEuMTI2MyAxLjgzMjE4TDQuODMxMDMgNS45OTk5OUwxLjEyNjMgMTAuMTY3OFpNNi4xMjYzIDEwLjE2NzhDNS45NDI4NCAxMC4zNzQyIDUuOTYxNDMgMTAuNjkwMiA2LjE2NzgyIDEwLjg3MzdDNi4zNzQyMSAxMS4wNTcyIDYuNjkwMjUgMTEuMDM4NiA2Ljg3MzcxIDEwLjgzMjJMMTAuNTc4NCA2LjY2NDM2QzEwLjkxNTIgNi4yODU0NyAxMC45MTUyIDUuNzE0NTIgMTAuNTc4NCA1LjMzNTYzTDYuODczNzEgMS4xNjc4MUM2LjY5MDI1IDAuOTYxNDIxIDYuMzc0MjEgMC45NDI4MzEgNi4xNjc4MiAxLjEyNjI5QzUuOTYxNDMgMS4zMDk3NSA1Ljk0Mjg0IDEuNjI1NzggNi4xMjYzIDEuODMyMThMOS44MzEwMyA1Ljk5OTk5TDYuMTI2MyAxMC4xNjc4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";